import axios from 'axios'

export interface Psap {
    id: number
    psapId: number
    name: string
    state: string
    county: string
    city: string
}

export function findPsaps() {
    return axios.get<Psap[]>(`/api/v1/psap/`)
}

export function getPsap(id: number) {
    return axios.get<Psap>(`api/v1/psap/${id}`)
}

export function editPsap(psapId: number, psap: Partial<Psap>) {
    return axios.patch(`/api/v1/psap/${psapId}`, psap)
}
